/**
 * FAQ custom select dropdown
 * @source : https://jssecrets.com/how-to-build-custom-javascript-select-dropdown/
 */

/**
 * Add identifiers for first and last block
 */
const faqDropdown = () => {

  // dropdown container
  const dropdown = document.querySelector(".faq-dropdown");
  // input
  const input = document.querySelector(".faq-dropdown__input");
  // dropdown list elements
  const listOfOptions = document.querySelectorAll(".faq-dropdown__option");
  const body = document.body;

  // abort if dropdown does not exist
  if (!dropdown) {
    return;
  }

  // Functions

  // basic toggle (open/close) function
  // "classList.toggle(className)" toggles 'opened' class
  const toggleDropdown = (event) => {
    event.stopPropagation();
    dropdown.classList.toggle("opened");
  };
  // option selection from dropdown list
  // used "event.currentTarget" to specify the selected option
  // after option is chosen, its "textContent" value being copied to input's value
  const selectOption = (event) => {
    input.value = event.currentTarget.textContent;

    document.querySelector("#" + event.currentTarget.dataset.scroll).scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });

  };

  // we want the dropdown list to close when clicked outside of it
  // ex: no option was selected
  // we do a simple check below
  // if dropdown list is in opened state
  // then remove the ".opened" class
  const closeDropdownFromOutside = () => {
    if (dropdown.classList.contains("opened")) {
      dropdown.classList.remove("opened");
    }
  };
  // Event Listeners
  // if we click anywhere on "body" and dropdown list opened
  // the dropdown will be closed
  body.addEventListener("click", closeDropdownFromOutside);
  // options selection
  listOfOptions.forEach((option) => {
    option.addEventListener("click", selectOption);
  });
  // dropdown toggle
  dropdown.addEventListener("click", toggleDropdown);
};
faqDropdown();
